export class ServiceCacheData {
    key: string;
    value: any;
    insertTime: Date = new Date;
    keepTime: number; //this would be in seconds
}


// WEBPACK FOOTER //
// ./src/app/models/common/serviceCacheData.ts